import {Grid, Surface, useTheme} from "tmwx-design-web/src";
import MeasurementLocationList from "../../components/efe/MeasurementLocationList";

const MeasurementLocation = () => {
    const { roundness } = useTheme()

    return (
        <Surface style={{ height: '100vh', paddingTop: 8, paddingBottom: 8 }}>
            <Grid.Container style={{ borderRadius: roundness }} maxWidth='xl' elevation={0} centered>
                <Grid.Col>
                    <MeasurementLocationList />
                </Grid.Col>
            </Grid.Container>
        </Surface>
    )
}

export default MeasurementLocation;